import type {ResolvedRequest} from './route';

export type RequestMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export type RequestBodyValue =
  | RequestInit['body']
  | object
  | ReadonlyArray<unknown>
  | string
  | number
  | boolean
  | null;

export interface RequestUserContext {
  id: string;
  role: string;
  email: string;
}

export interface RequestTelemetryRedactionConfig {
  sensitiveHeaders?: Iterable<string>;
  sensitiveKeys?: Iterable<string>;
  exposedHeaders?: Iterable<string>;
  exposedKeys?: Iterable<string>;
}

export interface RequestTelemetryRedactionResolvedConfig {
  sensitiveHeaders: string[];
  sensitiveKeys: string[];
  exposedHeaders: string[];
  exposedKeys: string[];
}

export enum RequestResponseType {
  JSON = 'json',
  TEXT = 'text',
  BLOB = 'blob',
  STREAM = 'stream',
}

export interface RequestOptions extends Omit<
  RequestInit,
  'body' | 'headers' | 'method' | 'signal' | 'cache' | 'credentials'
> {
  method?: RequestMethod;
  headers?: HeadersInit;
  body?: RequestBodyValue;
  credentials?: RequestCredentials;
  cache?: RequestCache;
  signal?: RequestInit['signal'];
  next?: {
    revalidate?: number;
    tags?: string[];
  };
  timeoutMs?: number;
  userContext?: Partial<RequestUserContext>;
  responseType?: RequestResponseType;
}

export interface RequestRawResult {
  response: Response;
  resolvedRequest: ResolvedRequest;
  parsedData: unknown;
}

export type RequestFailureReason = 'timeout' | 'abort' | 'network' | 'unknown';

export interface RequestFailureLogContext {
  message: string;
  status?: number;
  url?: string;
  method?: RequestMethod;
  requestId?: string;
  name?: string;
  stack?: string;
  failureReason?: RequestFailureReason;
}

export interface RequestTelemetryRedactionState {
  exposedHeaders: Set<string>;
  exposedKeys: Set<string>;
  sensitiveHeaders: Set<string>;
  sensitiveKeys: Set<string>;
}
